import CryptoJS from "crypto-js";
import { commonURI, commonUriAll } from "../CommonUrlList/CommonUrlList";
import cryptoJs from "crypto-js";
// Decryption for Master and PriceRate
const DecryptOrderKey = "w8uephFsev5B1cuW"
// const DecryptOrderKey = process.env.REACT_APP_DECRYPTORDERKEY
const DecryptOKey = ["r", "j", "#", "m", "^", "e", "4", "*", "s", "@", "h", "C", "$", "0", "v", "X", "a", "9", "#", "E", "z", "!", "X", "e", "b", "*"];
// const DecryptOKey = (process.env.REACT_APP_DECRYPTOKEY).split(" ")

const KeyIV = ["!", "$", "@", "^", "#", "*", "~"];
// const KeyIV = (process.env.REACT_APP_KEYIV).split(" ");

const decryptAES256 = (password) => {
    // "0V27WqAzmrZRSL2A0V27WqAzmrZRSL2A", "0V27WqAzmrZRSL2A"
    let _key = CryptoJS.enc.Utf8.parse("0V27WqAzmrZRSL2A0V27WqAzmrZRSL2A");
    let _iv = CryptoJS.enc.Utf8.parse("0V27WqAzmrZRSL2A");
    let decrypted = CryptoJS.AES.decrypt(
        password, _key,
        {
            iv: _iv,
            format: CryptoJS.format.Hex,
            mode: CryptoJS.mode.CTR,
            padding: CryptoJS.pad.NoPadding
        }).toString(CryptoJS.enc.Utf8);
    return decrypted;
}

const decryptData = (data) => {
    try {
        if (data !== null && data !== "") {
            const bytes = CryptoJS.AES.decrypt(data, DecryptOrderKey);
            if (bytes.toString()) {
                return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            }
            return data;
        }
        else
            return "";
    }
    catch (e) {
        return
    }
}

const erd = (e, r) => {
    const k1 = []; const k2 = []; let t = (r * Math.random() * r).toString(); e = e.filter(it => { return KeyIV.indexOf(it) < 0; }); for (var w = e.length - 1; w >= 0; w--) { if (e[0] === 'e' && e[1] === 'v') { if (w >= e.length / 2) k1.push(e[w]); else k2.push(e[w]); } else if (e[0] === 'B' && e[1] === 'j' && e[e.length - 1] === 'C') { if (w >= e.length / 2) k1.push(e[w]); else k2.push(e[w]); } else if (e[0] === 'M' && e[1] === 'y' && e[e.length - 1] === 'F') { if (w >= e.length / 2) k1.push(e[w]); else k2.push(e[w]); } else if (e[0] === 'r' && e[1] === 'j' && e[e.length - 1] === 'b') { if (w >= e.length / 2) k1.push(e[w]); else k2.push(e[w]); } r++; if (w > 0) { t += t; } else { t = k1.join("") + "" + k2.reverse().join(""); } } return t.substring(1, e.length / 2) + "" + t.substring((e.length / 2) + 1);
}

const DecryptOrderFunctionPrice = (cipherText, ciph) => {
    const key = CryptoJS.enc.Utf8.parse(erd(DecryptOKey, parseInt(decryptData(ciph))));
    const iv = CryptoJS.enc.Utf8.parse(erd(DecryptOKey, parseInt(decryptData(ciph))));
    const encrypt = CryptoJS.AES.decrypt(cipherText, key,
        {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
    return encrypt.toString(CryptoJS.enc.Utf8);
}
const DecryptKeyMaster = ["*", "L", "~", "j", "m", "!", "e", "4", "#", "s", "h", "$", "C", "0", "$", "v", "X", "a", "9", "E", "@", "z", "X", "e", "^", "9"];
// const DecryptKeyMaster = (process.env.REACT_APP_DECRYPTKEYMASTER).split(" ")
const KeyIV6 = ["!", "$", "@", "^", "#", "*", "~"];
// const KeyIV6 = (process.env.REACT_APP_KEYIV6).split(" ");
const L = (e, r) => {
    const k1 = []; const k2 = []; let t = (r * Math.random() * r).toString(); e = e.filter(it => { return KeyIV6.indexOf(it) < 0; }); for (var w = e.length - 1; w >= 0; w--) { if (e[0] === 'e' && e[1] === 'v') { if (w >= e.length / 2) k1.push(e[w]); else k2.push(e[w]); } else if (e[0] === 'u' && e[1] === 'y' && e[e.length - 1] === 'C') { if (w >= e.length / 2) k1.push(e[w]); else k2.push(e[w]); } else if (e[0] === 'M' && e[1] === 'y' && e[e.length - 1] === 'F') { if (w >= e.length / 2) k1.push(e[w]); else k2.push(e[w]); } else if (e[0] === 'L' && e[1] === 'j' && e[e.length - 1] === '9') { if (w >= e.length / 2) k1.push(e[w]); else k2.push(e[w]); } r++; if (w > 0) { t += t; } else { t = k1.join("") + "" + k2.reverse().join(""); } } return t.substring(1, e.length / 2) + "" + t.substring((e.length / 2) + 1);
}

const MyOwnDecryptFun = (cipherText) => {
    var bytes = CryptoJS.AES.decrypt(cipherText, 'nodejsbroadcastapidata');
    var originalText = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(originalText)
}

const DecryptOrderFunctionMaster = (cipherText, ciph = "") => {
    var key;
    var iv;
    // if (ciph === "U2FsdGVkX1+Zdq/7v1tYigFUbuuWOOv9aNCYdBlS1BM=") {
    if (ciph === process.env.REACT_APP_KEYFORMASTER1) {
        key = CryptoJS.enc.Utf8.parse(L(DecryptKeyMaster, parseInt(decryptData(ciph))));
        iv = CryptoJS.enc.Utf8.parse(L(DecryptKeyMaster, parseInt(decryptData(ciph))));
    }
    else if (ciph === process.env.REACT_APP_KEYFORMASTER2) {
        key = CryptoJS.enc.Utf8.parse(L(DecryptKeyMaster, parseInt(decryptData(ciph))));
        iv = CryptoJS.enc.Utf8.parse(L(DecryptKeyMaster, parseInt(decryptData(ciph))));
    }
    else if (ciph === process.env.REACT_APP_KEYFORMASTER3) {
        key = CryptoJS.enc.Utf8.parse(L(DecryptKeyMaster, parseInt(decryptData(ciph))));
        iv = CryptoJS.enc.Utf8.parse(L(DecryptKeyMaster, parseInt(decryptData(ciph))));
    }
    else {
        key = CryptoJS.enc.Utf8.parse(DecryptOrderKey);
        iv = CryptoJS.enc.Utf8.parse(DecryptOrderKey);
    }

    var encrypt = CryptoJS.AES.decrypt(cipherText, key,
        {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
    return encrypt.toString(CryptoJS.enc.Utf8);
}

// End-Master,PriceRate

//Encryption and decryption for login
const DecryptUserKey2 = ["@", "$", "y", "L", "r", "F", "~", "h", "a", "U", "n", "*", "K", "T", "j", "n", "p", "$", "O", "e", "^", "t"];
// const DecryptUserKey2 = (process.env.REACT_APP_DECRYPTUSERKEY2).split(" ");
const DecryptUserKey = ["e", "v", "*", "5", "B", "!", "1", "c", "u", "$", "W", "s", "F", "!", "h", "p", "@", "e", "u", "^", "8", "w"];
// const DecryptUserKey = (process.env.REACT_APP_DECRYPTUSERKEY).split(" ");
// DecryptOrderKey = ["e", "v", "*", "5", "B", "!", "1", "c", "u", "$", "W", "s", "F", "!", "h", "p", "@", "e", "u", "^", "8", "w"];
const KeyIvUser = ["!", "$", "@", "^", "#", "*", "~"];
// const KeyIvUser = (process.env.REACT_APP_KEYIVUSER).split(" ")
const DecryptSocket = ["y", "!", "k", "9", "C", "*", "z", "o", "$", "q", "o", "^", "W", "b", "f", "$", "8", "O", "2", "@", "Z", "F"];
// const DecryptSocket = (process.env.REACT_APP_DECRYPTSOCKET).split(" ")
const rsk = (k, i) => {
    const k1 = []; const k2 = []; let t = (i * Math.random() * i).toString(); k = k.filter(it => { return KeyIvUser.indexOf(it) < 0; });
    for (var w = k.length - 1; w >= 0; w--) {
        if (k[0] === 'e' && k[1] === 'v') { if (w >= k.length / 2) k1.push(k[w]); else k2.push(k[w]); } else if (k[0] === 's' && k[1] === 'v') { if (w >= k.length / 2) k1.push(k[w]); else k2.push(k[w]); } else if (k[0] === 'y' && k[1] === 'k') { if (w >= k.length / 2) k1.push(k[w]); else k2.push(k[w]); } else if (k[0] === 'y' && k[1] === 'L') { if (w >= k.length / 2) k1.push(k[w]); else k2.push(k[w]); } i++;
        if (w > 0) { t += t; } else { t = k1.join("") + "" + k2.reverse().join(""); }
    } return t;
}

const rsk2 = (k, i) => {
    const k1 = []; const k2 = []; let t = (i * Math.random() * i).toString(); k = k.filter(it => { return KeyIvUser.indexOf(it) < 0; }); for (var w = k.length - 1; w >= 0; w--) { if (k[0] == 'e' && k[1] == 'v') { if (w >= k.length / 2) k1.push(k[w]); else k2.push(k[w]); } else if (k[0] == '3' && k[1] == 'D' && k[k.length - 2] == 'w' && k[k.length - 1] == '5') { if (w >= k.length / 2) k1.push(k[w]); else k2.push(k[w]); } else if (k[1] == 'z' && k[0] == 'M' && k[k.length - 2] == '3' && k[k.length - 1] == 'L') { if (w >= k.length / 2) k1.push(k[w]); else k2.push(k[w]); } else if (k[0] == 'y' && k[1] == 'L' && k[k.length - 2] == 't' && k[k.length - 1] == 'e') { if (w >= k.length / 2) k1.push(k[w]); else k2.push(k[w]); } else if (k[1] == 'n' && k[0] == 'S' && k[k.length - 2] == 'r' && k[k.length - 1] == '7') { if (w >= k.length / 2) k1.push(k[w]); else k2.push(k[w]); } else if (k[0] == 'j' && k[1] == 'C' && k[k.length - 2] == '3' && k[k.length - 1] == 'P') { if (w >= k.length / 2) k1.push(k[w]); else k2.push(k[w]); } i++; if (w > 0) { t += t; } else { t = k1.join("") + "" + k2.reverse().join(""); } } return t.substring(2, k.length / 2) + "" + t.substring((k.length / 2) + 2);
}

const EncryptOrderFun = (OrderInformation) => {
    var key = CryptoJS.enc.Utf8.parse(rsk(DecryptUserKey, 0));
    var iv = CryptoJS.enc.Utf8.parse(rsk(DecryptUserKey, 0));

    var encrypt = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(OrderInformation), key,
        {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
    return encrypt;
}

const encryptAES256 = (text) => {
    let _key = CryptoJS.enc.Utf8.parse("0V27WqAzmrZRSL2A0V27WqAzmrZRSL2A");
    let _iv = CryptoJS.enc.Utf8.parse("0V27WqAzmrZRSL2A");
    let decrypted = CryptoJS.AES.encrypt(
        text, _key,
        {
            iv: _iv,
            format: CryptoJS.format.Hex,
            mode: CryptoJS.mode.CTR,
            padding: CryptoJS.pad.NoPadding
        }).toString();
    return decrypted;
}

const DecryptOrderFunction = (cipherText, type, MID, notJson) => {
    var key = CryptoJS.enc.Utf8.parse(rsk(DecryptUserKey, 0));
    var iv = CryptoJS.enc.Utf8.parse(rsk(DecryptUserKey, 0));

    var encrypt = CryptoJS.AES.decrypt(cipherText, key,
        {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
    if (type === 1) {
        return encrypt.toString(CryptoJS.enc.Utf8) + "-" + MID
    } else if (notJson === "notjson") {
        return encrypt.toString(CryptoJS.enc.Utf8)
    } else {
        return JSON.parse(encrypt.toString(CryptoJS.enc.Utf8));
    }
}

const DecryptKKey = ["M", "z", "*", "e", "~", "v", "5", "#", "B", "1", "c", "^", "u", "!", "W", "s", "$", "F", "h", "#", "p", "e", "*", "u", "8", "!", "w", "3", "L", "*"];

const stackDecrypt = (cipherText) => {
    var key = CryptoJS.enc.Utf8.parse(rsk2(DecryptKKey, 0));
    var iv = CryptoJS.enc.Utf8.parse(rsk2(DecryptKKey, 0));

    var encrypt = CryptoJS.AES.decrypt(cipherText, key,
        {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
    return (encrypt.toString(CryptoJS.enc.Utf8));
}

const encryptSocketFunction = (OrderInformation) => {
    var key = CryptoJS.enc.Utf8.parse(rsk(DecryptSocket, 2));
    var iv = CryptoJS.enc.Utf8.parse(rsk(DecryptSocket, 2));

    var encrypt = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(OrderInformation), key,
        {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
    return encrypt;
}

const encryptUserFunction = (OrderInformation) => {
    var key = CryptoJS.enc.Utf8.parse(rsk(DecryptUserKey2, 3));
    var iv = CryptoJS.enc.Utf8.parse(rsk(DecryptUserKey2, 3));

    var encrypt = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(OrderInformation), key,
        {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
    return encrypt;
}
const decryptSocketFunction = (cipherText) => {
    if (cipherText !== undefined) {
        var key = CryptoJS.enc.Utf8.parse(rsk(DecryptSocket, 2));
        var iv = CryptoJS.enc.Utf8.parse(rsk(DecryptSocket, 2));

        var encrypt = CryptoJS.AES.decrypt(cipherText, key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
        return encrypt.toString(CryptoJS.enc.Utf8);
    } else {
        return
    }
}

//Iframe setter

const setLiveScoreIfreame = (eventId) => {
    let TVURL = commonURI.__LIVE_SCORE_NEW_URL + "?params=" + eventId + "&param=" + 4;
    var iFrameNew = '<iframe src="' + TVURL + '" allowtransparency="true" marginwidth="0" marginheight="0" frameborder="0" height="150px" width="100%" scrolling="no"></iframe>';
    var iframeId = document.getElementById("__LIVESCOREURL")
    if (iframeId) {
        iframeId.innerHTML = iFrameNew
    }
}

export { stackDecrypt, setLiveScoreIfreame,encryptAES256, decryptData, DecryptOrderFunction, decryptAES256, EncryptOrderFun, DecryptOrderFunctionPrice, encryptSocketFunction, MyOwnDecryptFun, encryptUserFunction, DecryptOrderFunctionMaster, decryptSocketFunction }